import { signOut } from 'firebase/auth';
import { auth } from '@/firebase';

async function logout(): Promise<void> {
  await signOut(auth);
}

export default {
  logout,
};
